module.exports = __webpack_public_path__ + "static/media/dance.e745b89a.svg";